<template>
    <div class="container-fluid-infomode">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="descriptionmode"> WWWWWWWLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </h2>
            <img class="btnpublicidad" src="@/assets/bannerpublicidad.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
      export default {
    name: 'InfoMode',
    props: {
      msg: String
    }
  }
  </script>